import { TransferTransactionModel } from './transfer_transaction_model';

angular
  .module('capability-ng-transfer')
  .service('ngTransferMajorTransactionModel', () => new TransferTransactionModel());



// WEBPACK FOOTER //
// ./app/lib/transfer/models/transfer_major_transaction_model.ts